import Api from 'utils/api'

export const fetchProjectTemplates = ({ limit, offset, ordering, search }) =>
  Api.get(['projecttemplates'], { limit, offset, ordering, search })

export const postCopyProjectTemplate = ({ title, department, uuid }) =>
  Api.post(['projecttemplates', uuid, 'copy'], { title, department })

export const postProjectTemplate = payload =>
  Api.post(['projecttemplates'], payload)

export const updateProjectTemplate = (id, payload) =>
  Api.patch(['projecttemplates', id], payload)
